module.exports = __webpack_public_path__ + "3fe03a33e187569c4b230772a95f7a69.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_150.jpg
// module id = 1732
// module chunks = 5